
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { editProductPlugin, getTagList } from '@/api/app'
import LogoUploader from '@/components/LogoUploader/index.vue'
import axios from 'axios'
import { AppModule } from '@/store/modules/app'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

@Component({
  name: 'edit',
  components: {
    LogoUploader,
    quillEditor
  }
})
export default class extends Vue {
  @Prop({ required: true }) private appItem!: any

  private currencyLists: any[] = []
  private back() {
    this.$emit('close')
  }
  private infoForm: any = {}

  // private getLogo(logo: string) {
  //   this.infoForm.logo = logo
  // }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private loading: boolean = false
  private async pluginDetail() {
    this.loading = true
    const data: any = {
      ...this.infoForm
    }
    await await axios({
      url: this.development
        ? `https://dapi.zolopay.com/api/manage/open-product-plugin/${this.appItem.id}`
        : `https://dapi.paypptp.com/api/manage/open-product-plugin/${this.appItem.id}`,
      method: 'get',
      params: {
        corporation_id: AppModule.enterprise.corporation,
        enterprise_id: AppModule.enterprise.id,
        cloud_instance: AppModule.enterprise.cloud_instance
      }
    })
      .then((res: any) => {
        this.infoForm = res.data
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
  }
  private development: boolean = true
  mounted() {
    if (
      window.location.origin === 'https://manage.zolopay.com' ||
      window.location.hostname === 'localhost'
    ) {
      // 测试环境的处理逻辑
      this.development = true
    } else {
      // 正式环境的处理逻辑
      this.development = false
    }
    this.pluginDetail()
  }
}
